export default __webpack_public_path__ + "static/media/docker-logo.5acac4b4.svg";